<template>
    <div>
        <div @click="showAdd = !showAdd">
            <slot name="activator"></slot>
        </div>

        <app-input-dlg
                :show-dialog="showAdd"
                title="Add New User Group"
                :cancel-button="true"
                :show-input-box="false"
                @dismiss="showAdd = false"
                :body-padding="false"
        >
            <template slot="body">
                <div class="px-1 pt-1">
                    <div :class="topicClass">
                        <div :class="headingClass">
                            User Group Description:
                        </div>
                        <div :class="itemClass">
                            <v-text-field
                                    label="User Group Description"
                                    single-line
                                    color="primary"
                                    hide-details
                                    style="width: 100%"
                                    class="pa-0 ma-0"
                                    ref="UGroupDescription"
                                    v-model="addGroupDescription"
                            />
                        </div>
                    </div>
                    <div :class="topicClass">
                        <div :class="headingClass">
                            Select Users:
                        </div>
                        <div :class="itemClass">
                            <v-autocomplete
                                    :items="users"
                                    clearable
                                    color="primary"
                                    flat
                                    v-model="selectedUsers"
                                    hide-details
                                    class="pa-0 ma-0"
                                    single-line
                                    label="None Selected"
                                    item-text="description"
                                    item-value="id"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    chips
                            >
                            </v-autocomplete>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="actions">
                <div class="text-xs-right">
                    <v-btn
                            small
                            color="secondary"
                            :disabled="!Array.isArray(selectedUsers) || selectedUsers.length <= 0 || blankString(addGroupDescription) || addingUserGroup"
                            :loading="addingUserGroup"
                            @click="addUserGroup"
                    >
                        Add User Group
                    </v-btn>
                </div>
            </template>
        </app-input-dlg>
    </div>
</template>

<script>
    import {codeBaseMixin} from "../../../codeBaseMixin";
    import InputDlg from "../../../components/General/InputDlg";

    export default {
        components: {
            appInputDlg: InputDlg
        },
        mixins: [codeBaseMixin],
        props: {
            userInfo: Object,
            selectedFolderGroup: Object,
            users: Array,
        },
        data() {
            return {
                showAdd: false,
                addGroupDescription: null,
                selectedUsers: null,
                addingUserGroup: false,
            }
        },
        watch: {
            showAdd(shown) {
                if (shown) {
                    this.addGroupDescription = null;
                    this.selectedUsers = null;
                    this.addingUserGroup = false;
                    this.$nextTick(() => {
                        this.$refs.UGroupDescription.focus();
                    })
                }
            },
        },
        methods: {
            addUserGroup() {
                this.addingUserGroup = true;
                this.fetch({method: 'POST', url:`/folderManager/security/userGroup/${this.userInfo.entityID}/${this.selectedFolderGroup.id}`, body: JSON.stringify({description: this.addGroupDescription, users: this.selectedUsers})})
                    .then((data) => {
                        this.showAdd = false;
                        this.addingUserGroup = false;
                        this.$emit('userGroupAdded', data);
                        this.showSnack('Info', 'User Group Added', 'Close', 'primary');
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.addingUserGroup = false;
                    })
            }
        },
        computed: {
            filteredSelectedUserGroups() {

                    return this.blankString(this.userGroupFilterString)
                        ? this.userGroups.filter(obj => true)
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1)

                        : this.userGroups
                            .reduce((list, userGroup) => {
                                if (
                                    [userGroup.description].concat(
                                        userGroup.members.map(user => {
                                            return typeof user != 'undefined' ? user.description : null
                                        }).join(', ')
                                    ).join(', ')
                                        .toLowerCase().includes(this.userGroupFilterString.toLowerCase())
                                ) {
                                    list.push(userGroup)
                                }
                                return list
                            }, [])
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1);


            },
        }

    }
</script>

<style scoped>

</style>
